module.exports = __webpack_public_path__ + "static/img/lu.25eb5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lu.png
// module id = vVop
// module chunks = 0